var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.47 12.14-.72.728c-.667.667-1.333 1.335-2.003 1.999a.708.708 0 0 1-.263.181.4.4 0 0 1-.469-.155.426.426 0 0 1 .004-.511c.045-.06.099-.112.152-.165.824-.825 1.65-1.651 2.476-2.475.052-.052.119-.09.193-.147-.081-.085-.13-.139-.182-.19L.233 7.978c-.311-.311-.315-.522.017-.819 1.765-1.578 3.784-2.048 6.063-1.382.072.02.19.025.233-.018.832-.818 1.655-1.645 2.513-2.503-.111-.1-.222-.187-.319-.287-.677-.7-.687-1.752-.024-2.438.66-.683 1.72-.714 2.435-.051.432.4.84.83 1.257 1.247 1.013 1.012 2.028 2.02 3.036 3.038.765.773.735 1.914-.056 2.593a1.723 1.723 0 0 1-2.272-.02c-.13-.117-.234-.264-.382-.433-.158.176-.274.318-.402.447-.674.678-1.349 1.357-2.03 2.028-.109.107-.12.193-.079.335.654 2.262.186 4.273-1.372 6.03-.3.34-.518.335-.837.016-1.132-1.132-2.264-2.264-3.395-3.398-.056-.057-.091-.135-.15-.224",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default ForwardRef;